<template>
    <AdminNextIframe
        path="/catalog-manager/"
        :query="{ clientId: $route.params.id }" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientCatalogManager',
    components: { AdminNextIframe }
}
</script>
